export default __webpack_public_path__ + "static/media/loginheaderbackground.45ae5f43.png";